module.exports = __webpack_public_path__ + "static/media/gallery-28.8d070b6e.jpg";